// src/services/auditService/annualFsStatusEnum.ts
// Sync with backend: core/common/enums/AnnualFsStatusEnum

export enum AnnualFsStatusEnum {
    ACCOUNT_EDITING = 1,
    AUDIT_EDITING = 2,
    AUDIT_ADJUSTMENT = 3,
    COMPLETED = 4,
}
